import api from "../../../services/api";
import { buildRelatorioWithPayload } from "./model";

const postRelatorio = async (url, filterData, signal) => {
  const response = await api.post(url, buildRelatorioWithPayload(filterData), {
    signal,
  });
  return response?.data;
};

export const relatorioWithController = {
  getConsolidado: (filterData, signal) =>
    postRelatorio("/find/reincidencia/consolidado", filterData, signal),
  getMotivos: (filterData, signal) =>
    postRelatorio("/find/reincidencia/motivos", filterData, signal),
  getRegional: (filterData, signal) =>
    postRelatorio("/find/reincidencia/regional", filterData, signal),
  getTecnicos: (filterData, signal) =>
    postRelatorio("/find/reincidencia/tecnicos", filterData, signal),
  getAtendimento: (filterData, signal) =>
    postRelatorio("/find/reincidencia/atendimento", filterData, signal),
  getSetor: (filterData, signal) =>
    postRelatorio("/find/reincidencia/setor", filterData, signal),
  getCidade: (filterData, signal) =>
    postRelatorio("/find/reincidencia/cidade", filterData, signal),
  getCurvaDiaria: (filterData, signal) =>
    postRelatorio("/find/reincidencia/curva-diaria", filterData, signal),
  getSpcSemanal: (filterData, signal) =>
    postRelatorio("/find/reincidencia/spc-semanal", filterData, signal),
  // DESATIVADO (Abertura → Fechamento): para voltar, descomente aqui, em index.js (estado, fetch e prop), em tendenciasCausaRaiz.js (card) e a rota no backend.
  // getFluxoMotivos: (filterData, signal) =>
  //   postRelatorio("/find/reincidencia/fluxo-motivos", filterData, signal),
  getMatrizTipoMotivo: (filterData, signal) =>
    postRelatorio("/find/reincidencia/matriz-tipo-motivo", filterData, signal),
  getFluxoAnterior: (filterData, signal) =>
    postRelatorio("/find/reincidencia/fluxo-anterior", filterData, signal),
  getHeatmapCidadeMotivo: (filterData, signal) =>
    postRelatorio("/find/reincidencia/heatmap-cidade-motivo", filterData, signal),
  getCronicos: (filterData, signal) =>
    postRelatorio("/find/reincidencia/cronicos", filterData, signal),
  // Técnicos/atendentes vêm do HubSoft escolhido.
  getFiltros: (erpId, signal) =>
    api.post(
      "/find/reincidencia/filtros",
      { erpId: erpId || undefined },
      { signal },
    ),
};
